import { render } from "./ApiTransactionListComponent.vue?vue&type=template&id=af089ba8&scoped=true"
import script from "./ApiTransactionListComponent.vue?vue&type=script&lang=js"
export * from "./ApiTransactionListComponent.vue?vue&type=script&lang=js"

import "./ApiTransactionListComponent.vue?vue&type=style&index=0&id=af089ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af089ba8"]])

export default __exports__